import React from 'react'
import '../main.css'

const ListHeaders = (props) => {
    return (
        <div className={"first-background-color lists-main-container"}>
            {props.data.map(d => {
                return (
                    <p className={d.className}><strong>{d.header}</strong></p>
                )
            })}
        </div>
    )
}

export default ListHeaders